import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { t } from "@/i18n-js/instance";
import { useMarkAllChatRoomAsRead } from "@/react/hooks/chatsV2/useMarkAllChatRoomAsRead";
import { useShouldShowMessagingRoutes } from "@/react/hooks/useIsMessagingEnabled";

export const MarkAsReadButton = () => {
  const { showMessagesTab: shouldShowMessagesTab } =
    useShouldShowMessagingRoutes();

  const { markAllChatRoomAsRead, isLoading } = useMarkAllChatRoomAsRead();

  if (!shouldShowMessagesTab) {
    return null;
  }

  return (
    <Tooltip content={t("header_v3.mark_all_as_read")}>
      <IconButton
        icon="checkmark-double"
        variant="ghost"
        size="md"
        onClick={() => markAllChatRoomAsRead()}
        loading={isLoading}
        aria-label={t("header_v3.mark_all_as_read")}
      />
    </Tooltip>
  );
};
